import React from 'react';
// up

// Create a separate context file to avoid circular imports
const HoleContext = React.createContext({
  currentHole: 1,
  setCurrentHole: () => {},
  maxHoles: 18,
  serverRoundDuration: 0
});

export { HoleContext };